const userStatusTypes = {
    SIGNED_OUT: 'SignedOut',
    PAUSED: 'Paused',
    ACTIVE_GRACE: 'ActiveGrace',
    ACTIVE_PAID: 'ActivePaid',
    FREE_TRIAL: 'FreeTrial',
    FROZEN: 'Frozen',
    BLOCKED: 'Blocked',
    EXPIRED: 'Expired',
    EXPIREDMARKETING: 'ExpiredMarketing',
    PARTIAL: 'Partial'
};

export {userStatusTypes};
